<style lang="scss" src='./SensorChart.scss' scoped></style>
<template src="./SensorChart.html"></template>

<script>
import ApexChart from 'vue-apexcharts';
import {
    getSensorGraph,
    getSensor,
    getStationGraph
  } from '@/api/index';

let CounterForUpdates = 0;

import i18n from './../../../../i18n';

import {
    mapState,
    mapActions,
    mapMutations,
  } from 'vuex';

  export default {
  name: 'SensorChart',
  props: {
    sensor: {
      required: false,
    },

    station:{
      required: false,
    },

    alert: {
      requiered: false,
    },
  },
  
  components: {
      ApexChart,
  },

  data() {
    return ({
      loading: true,
      filters: {
        daysBack: null,
        threshold: null,
      },
      series: [{
          data: []
      }],
      options: [
          { text: this.$t('timePeriods.1D'), label: this.$t('timePeriods.last24H'), value: 1, },
          { text: this.$t('timePeriods.2D'), label: this.$t('timePeriods.last2D'), value: 2, },
          { text: this.$t('timePeriods.1W'), label: this.$t('timePeriods.lastWeek'), value: 7, },
          { text: this.$t('timePeriods.1M'), label: this.$t('timePeriods.lastMonth'), value: 30, },
          { text: this.$t('timePeriods.1Y'), label: this.$t('timePeriods.lastYear'), value: 365, },
        ],
      charOpt: {
          xaxis: {
            type: 'datetime',
          },
        },
    });
  },
  computed: {
    ...mapState("Dashboard", {
        microWeather: (state) => state.microWeather,
      }),
      
    ...mapState('Stations', {
        stations: (state) => state.stations,
        sel_station: (state) => state.station,
      }),

    noDataMessage() {
        return `${this.$t('timePeriods.noDataToShow')} ${this.filters.daysBack.label.toLowerCase()}`;
      },
  },
  watch: {
    sensor: function (newSensor, oldSensor) {
      if (newSensor && oldSensor && newSensor.sensor_id !== oldSensor.sensor_id) {
        this.loadData();
      }
    },
    station: function (newStation, oldStation) {
      if (newStation && oldStation && newStation.station_id !== oldStation.station_id) {
        this.loadData();
      }
    }
  },

  methods: {
    ...mapActions('Dashboard', ['loadWeather']),
    ...mapActions('Stations', ['apiGetStations']),
    ...mapMutations('Stations', ['setStation']),
    
    getETNote(){
      return i18n.t('sensors.etNoteWS');
    },

    getETStation() {
      let stationToReturn = null;
      
      if(this.microWeather && this.microWeather.length > 0){
        let maxEt = -1;
        
        for(let i = 0; i < this.microWeather.length; i++){
          let station = this.microWeather[i].last_reading;
          let station_et_rate = station.et_rate ? station.et_rate : -1;
          if(station_et_rate > maxEt){
            maxEt = station_et_rate;
            stationToReturn = this.microWeather[i].station;
          }
        }
      }
      return stationToReturn;
    },

    filterByDays(daysBack){
      this.filters.daysBack = daysBack;
      this.getGraph();
    },

    getMinMaxAliasString({ alias, prefix }){
      switch(alias){
        case 'vwc':
          return `${prefix}_moisture`
        case 'et_rate':
          return 'et_rate'
        case 'bulk_ec':
          return `${prefix}_salinity`
        default:
          return `${prefix}_${alias}`
      }
    },

    async getGraph() {

        this.loading = true;
        let tempChartOptions = this.getChartOptions();
        this.alertType = this.filters.threshold;
        let isETChart = false;
        let station = null;

        if(!this.alertType){
          this.alertType = {
            alias: 'rssi',
            key: 'rssi',
            uom: 'MINUTES',
            i18n: 'alerts.commFailure'
          }
        }

        this.unitOfMeasurament = this.G_getUOM({
          uom: this.alertType ? this.alertType.uom : this.alert.alert_type.uom
        });
        tempChartOptions.title.text = '.';
        tempChartOptions.yaxis.title.text = this.unitOfMeasurament;
  
        let data = {
          sensorId: this.sensor && this.sensor.sensor_id,
          alias: this.alertType.alias,
          min_alias: this.getMinMaxAliasString({ alias: this.alertType.alias, prefix: 'min' }),
          max_alias: this.getMinMaxAliasString({ alias: this.alertType.alias, prefix: 'max' }),
          until: this.filters.daysBack.value,
          device_sn: this.station && this.station.device_sn,
          resampleFreq: this.filters.daysBack.value == 365 ? '8h' : null
        };

        let tempMin = null;
        let tempMax = null;
        let apiCall = null;
        
        if(this.alert){
          apiCall = this.alert.station_id ? getStationGraph : getSensorGraph;
        }else{
          apiCall = getSensorGraph;
        }

        if(this.alertType.key == 'et_rate'){
          let station_info = this.getETStation();
          
          station = this.stations.find(x => x.station_id == station_info.station_id);
          
          if(station){
            isETChart = true;
            data = {
              stationId: null,
              alias: this.alertType.alias,
              min_alias: this.getMinMaxAliasString({ alias: this.alertType.alias, prefix: 'min' }),
              max_alias: this.getMinMaxAliasString({ alias: this.alertType.alias, prefix: 'max' }),
              until: this.filters.daysBack.value,
              device_sn: station.device_sn,
              resampleFreq: this.filters.daysBack.value == 365 ? '8h' : null
            };
            apiCall = getStationGraph;
          }
        }

        await apiCall(data).then((res) => {
          let tempSeries = [];
          let tempSeriesMax = [];
          let tempSeriesMin = [];
          
          if (res.length > 0) {

            console.log('RES SENSORS CHART', res, data)

            tempSeries = res.map((item) => {
              let reading = this.G_getMeasurement({
                  val: item[data.alias],
                  uom: this.alertType.uom,
                  addUnit: false,
                  invertUOM: false
                })
              if (tempMin == null) {
                tempMin = reading;
              } else {
                if (Number(reading) < Number(tempMin)) {
                  tempMin = Number(reading);
                }
              }
              if (tempMax == null) {
                tempMax = Number(reading);
              } else {
                if (Number(reading) > Number(tempMax)) {
                  tempMax = Number(reading);
                }
              }
              return [
                new Date(item.reading_time).getTime(),
                reading
              ]
            });

            tempSeriesMax = res.map((item) => {
              let reading = this.G_getMeasurement({
                  val: item[data.max_alias],
                  uom: this.alertType.uom,
                  addUnit: false,
                  invertUOM: false
                })
              if (tempMin == null) {
                tempMin = reading;
              } else {
                if (Number(reading) < Number(tempMin)) {
                  tempMin = Number(reading);
                }
              }
              if (tempMax == null) {
                tempMax = Number(reading);
              } else {
                if (Number(reading) > Number(tempMax)) {
                  tempMax = Number(reading);
                }
              }
              return [
                new Date(item.reading_time).getTime(),
                reading
              ]
            });

            tempSeriesMin = res.map((item) => {
              let reading = this.G_getMeasurement({
                  val: item[data.min_alias],
                  uom: this.alertType.uom,
                  addUnit: false,
                  invertUOM: false
                })
              if (tempMin == null) {
                tempMin = reading;
              } else {
                if (Number(reading) < Number(tempMin)) {
                  tempMin = Number(reading);
                }
              }
              if (tempMax == null) {
                tempMax = Number(reading);
              } else {
                if (Number(reading) > Number(tempMax)) {
                  tempMax = Number(reading);
                }
              }
              return [
                new Date(item.reading_time).getTime(),
                reading
              ]
            });
          }
          this.series = [{
            name: this.$t(this.alertType.i18n),
            data: tempSeries,
          },
          {
            name: 'Max',
            data: tempSeriesMax,
          },
          {
            name: 'Min',
            data: tempSeriesMin,
          }
          ];
        });
        let min = 0;
        let max = 0;

        /* Ommit annotations
        if (this.alert && this.alert.station_id) {
          if(this.alert.alert_type_id != "WS_COMMUNICATION_FAILURE"){
            const threshold = this.alert.station.thresholds.find(t => t.alert_type_id === this.alert.alert_type_id);
            const maxTh = threshold.max ? this.G_getMeasurement({ val: threshold.max, uom: threshold.alert_type.uom }): null;
            const maxVal = threshold.alert_type.max ? this.G_getMeasurement({ val: threshold.alert_type.max, uom: threshold.alert_type.uom }): null;
            const minTh = threshold.min ? this.G_getMeasurement({ val: threshold.min, uom: threshold.alert_type.uom }): null;
            const minVal = threshold.alert_type.min ? this.G_getMeasurement({ val: threshold.alert_type.min, uom: threshold.alert_type.uom }): null;

            min = minTh;
            max = maxTh;
            tempMin= Number(minVal) < Number(tempMin) ? Number(minVal) : tempMin;
            tempMax= Number(maxVal) > Number(tempMax) ? Number(maxVal) : tempMax;

            if(min){
              tempChartOptions.annotations.yaxis[0].y = min;
              tempChartOptions.annotations.yaxis[0].label.text = 'Min ' + min + this.unitOfMeasurament
              tempChartOptions.annotations.yaxis[1].y = max;
              tempChartOptions.annotations.yaxis[1].label.text = 'Max ' + max + this.unitOfMeasurament;
            }else{
              tempChartOptions.annotations.yaxis[0].y = max;
              tempChartOptions.annotations.yaxis[0].label.text = 'Max ' + max + this.unitOfMeasurament;
              tempChartOptions.annotations.yaxis[1] = null;
            }
          }
        
        } else if (isETChart) {
          const station_threshold = station.thresholds.find(t => t.alert_type.alert_type_id === 'ET_RATE');
          min =
            this.G_getMeasurement({
              val: 2,
              uom: this.alertType.uom,
              addUnit: false,
              invertUOM: false
            });
          max =
            this.G_getMeasurement({
              val: 8,
              uom: this.alertType.uom,
              addUnit: false,
              invertUOM: false
            });
          tempChartOptions.annotations.yaxis[0].y = min;
          tempChartOptions.annotations.yaxis[0].label.text = 'Min ' + min + this.unitOfMeasurament
          tempChartOptions.annotations.yaxis[1].y = max;
          tempChartOptions.annotations.yaxis[1].label.text = 'Max ' + max + this.unitOfMeasurament;
        } else if (this.sensor.threshold && this.alertType.uom !== this.consts.UOM.RSSI) {
          min =
            this.G_getMeasurement({
              val: this.sensor.threshold[`min_${this.alertType.key}`],
              uom: this.alertType.uom,
              addUnit: false,
              invertUOM: false
            });
          max =
            this.G_getMeasurement({
              val: this.sensor.threshold[`max_${this.alertType.key}`],
              uom: this.alertType.uom,
              addUnit: false,
              invertUOM: false
            });
          tempChartOptions.annotations.yaxis[0].y = min;
          tempChartOptions.annotations.yaxis[0].label.text = 'Min ' + min + this.unitOfMeasurament
          tempChartOptions.annotations.yaxis[1].y = max;
          tempChartOptions.annotations.yaxis[1].label.text = 'Max ' + max + this.unitOfMeasurament;
        } else {
          tempChartOptions.annotations.yaxis = [];
          tempChartOptions.annotations.yaxis[0] = {
            label : {
            text : 'Min ' + min + this.unitOfMeasurament 
            }
          }
        }
        */
        tempChartOptions.annotations.yaxis = [];

        //let yaxisMin = (min < tempMin) ? min : tempMin;
        //tempChartOptions.yaxis.min = (yaxisMin > 0) ? 0 : yaxisMin;
        tempChartOptions.yaxis.min = Number(tempMin);
        //if (tempMax > max) {
        //  tempChartOptions.yaxis.max = tempMax;
        //} else {
        //  tempChartOptions.yaxis.max = max;
        //}
        tempChartOptions.yaxis.max = Number(tempMin) == Number(tempMax) ? Number(tempMax) + 0.05 : Number(tempMax);
        this.charOpt = tempChartOptions;
        this.loading = false;
    },

    getChartOptions() {
        return {
          chart: {
            type: 'area',
            animations: {
              enabled: false,
            },

            stacked: false,
            height: 350,
            zoom: {
              type: 'x',
              enabled: true,
              autoScaleYaxis: true
            },
            toolbar: {
              show: false,
            },
            events: {
              updated: function (chartContext, config) {
                if (CounterForUpdates != 0) {
                  var elmnt = document.getElementById("chart");
                  if (elmnt) {
                    elmnt.scrollIntoView();
                  }
                }
                ++CounterForUpdates;
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          // markers: {
          //   size: 0,
          //   colors: '#018ffb',
          //   strokeColors: '#018ffb',
          //   strokeWidth: 0,
          // },
          title: {
            text: 'title',
            align: 'left'
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.4,
              opacityTo: 0,
              stops: [0, 90, 100]
            },
          },
          stroke: {
            width: [3]
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val ? (val).toFixed(2) : 0;
              },
            },
            title: {
              text: 'unitOfMeasurament'
            },
            min: -5,
            max: 150,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'h:mm TT',
              },
            }
          },
          tooltip: {
            x: {
              show: true,
              formatter: (val) => {
                return this.G_formatDate({date: val, pretty: false});
              }
            },
            shared: false,
            y: {
              formatter: (val) => {
                return val ? `${(val).toFixed(2)}${this.unitOfMeasurament}` : '';
              }
            }
          },
          annotations: {
            yaxis: [{
              y: 10,
              borderColor: 'red',
              label: {
                borderColor: 'red',
                style: {
                  color: '#fff',
                  background: 'red',
                },
                text: 'Min',
              }
            }, {
              y: 60,
              borderColor: 'red',
              label: {
                borderColor: 'red',
                style: {
                  color: '#fff',
                  background: 'red',
                },
                text: 'Max',
              }
            }, ],
          }
        }
      },

    loadData() {
      if (this.sensor){
        this.getGraph();
      }
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {

    this.apiGetStations();

    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Sensors Charts");
      this.$analytics.logEvent("web_sensors_charts");
    }

    this.loadWeather();

    CounterForUpdates = 0;
    this.filters.daysBack = this.options[0];
    this.filters.threshold = this.consts.THRESHOLDS[0];

    if(this.station && this.alert && this.alert.alert_type){
      let alertType = this.consts.AlertType[this.alert.alert_type_id];

      if(alertType){
        this.filters.threshold = alertType;
      }
    } else if (this.alert && this.alert.alert_type) {
      this.filters.threshold = this.consts.THRESHOLDS.find(
        (t) =>  t.uom === this.alert.alert_type.uom
      );
    } else {
      this.filters.threshold = this.consts.THRESHOLDS[0];
    }

    this.getGraph();
  },
};
</script>
